import React from 'react';

import { Flex, Paragraph, IconButton } from '@vimeo/bokeh';
import { DownloadImport } from '@vimeo/bokeh-icons';
import type { TextTrack } from '@vimeo/gctl-api/models/components/schemas/text-track/TextTrack';
import { translate } from '@vimeo/i18n-runtime';

const DownloadTranscriptsContent = ({
  files,
  registerClick,
}: {
  /** Text track download files source */
  files: TextTrack[];
  registerClick: (lang: string | null) => void;
}) => {
  return (
    <Flex direction="column" w="100%" py="100">
      <Flex gap="1.75rem" direction="column">
        {files.map((file) => {
          return (
            <Flex align="center" justify="space-between" key={file.id}>
              <Paragraph size="lg" fontWeight="500" minW="3.13rem">
                {file.displayLanguage}
              </Paragraph>
              <IconButton
                aria-label={translate('Download')}
                as="a"
                href={file.link}
                variant="secondary"
                icon={<DownloadImport />}
                onClick={() => registerClick(file.language)}
              />
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default DownloadTranscriptsContent;
